module.exports = __webpack_public_path__ + "static/02-d40dd6de28cf683bee43a2349c4c1f8c.png";